import AttendanceSerializer from './base';

export default class Audit extends AttendanceSerializer {}
